import { EventEmitter } from '@angular/core';
import { ViewContainerRef } from '@angular/core';
import { Component, OnInit, Input, Output } from '@angular/core';
import { InteractService } from 'app/BaseFramework/core/services/interact/interact.service';
import { ComponentOutputDO } from 'app/BaseFramework/shared/models/common.model';
import { DataTransformService } from 'app/ViewModules/shared-services/data-transform/data-transform.service';
import { ApiRequestService } from 'app/BaseFramework/core/http/api-request.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import {
  AppMetadataHandler,
  CommonUtilty
} from 'app';
/* MOCKS: For DEMO ALONE -- Replace with API Calls during dev. */
//import { default as DATA_DFC } from './demo-fraud-clusters.json';
import DATA_DFC from './demo-fraud-clusters.json';
//import { default as DATA_CLUSTR } from './../mocks/clusters.json';
//import { default as DATA_FRULES } from './../mocks/fraud-rules.json';
//import { default as DATA_FTYPES } from './../mocks/fraud-types.json';
//import { default as DATA_RULES_N_ANOMALIES } from './../mocks/rules-and-anomalies.json';
/* END MOCKS */

@Component({
  selector: 'app-fraud-rules',
  templateUrl: './fraud-rules.component.html',
  styleUrls: ['./fraud-rules.component.scss'],
})

export class FraudRulesComponent implements OnInit {

  _currentComponentName = 'FraudRulesComponent'

  // USER
  @Input() userType: 'adjudicator' | 'investigator' | 'adjudicator-post-investigation' = 'adjudicator';

  @Output() componentOutput = new EventEmitter<any>();
  @Input() transactionState;
  @Input() barcodeNum;
  @Input() enableFraudRulePanel = true;
  @Input() enableAnomalyPanel = true;
  clientDoList  
  primaryInsured = null


 // referenceNum: any = this.getBarcodeAndReturnNumber(this.dataTransformService['activeTransactionStore'].currentAllComponentData['HealthClaimsBasicDetailsComponent']['barCodeNum']);
 _referenceNum: any 
  userDetails
  //JUGAAD for demo
  getBarcodeAndReturnNumber(data) {
    if(data){
    if (data.includes('1'))
      return 1
    else if (data.includes('2'))
      return 2
    else if (data.includes('3'))
      return 3
    else if (data.includes('4'))
      return 4
    else if (data.includes('5'))
      return 5
    else if (data.includes('6'))
    return 6
    else if (data.includes('7'))
    return 7
    }else{
      return 9
    }

  }


  set referenceNum(val){
    this._referenceNum=val;
  }
  get referenceNum(){
    if(this.barcodeNum)
    return this.getBarcodeAndReturnNumber(this.barcodeNum)
    else
    return 'default'
  }

  userTypes = [
    { id: 'adjudicator', name: 'Adjudication' },
    { id: 'investigator', name: 'Investigation' },
    { id: 'adjudicator-post-investigation', name: 'Adj. after Investigation' },
  ];
  // DATA SAMPLES
  dataSamples = ['Low', 'Medium', 'High'].reverse();
  dataSample = this.dataSamples[0];

  /* Range, Color config. */
  ranges = [
    { name: "default", bg: "", color: "#8d8d8d", min: -1, max: 9 },
    { name: "low", bg: "", color: "#7a8c0a", min: 10, max: 44 },
    { name: "medium", bg: "", color: "#ef8a31", min: 45, max: 69 },
    { name: "high", bg: "", color: "#d63f3f", min: 70, max: 100 },
  ];

  fraudColor=this.ranges.find(e=>e.name=='high').color
  riskColor=this.ranges.find(e=>e.name=='high').color

  getColor(rating){
    if(rating)
    return this.ranges.find(e=>e.name==rating.toLowerCase()).color
  }
  /* Our Dataset for demo (replace with API calls) */
  dataSETDemo = {
    high: {
      propensity: 81,
      risk: "High",
      mainColor: this.ranges.find(e=>e.name=='high').color, // color for % graphs
      recco: 'Refer to Investigator',
      cna: [
        { id: 0, name: "All", type:"all", severity:"default", contribution: 100 }, // Special Case [Filter]
        // { id: 1, name: "Hospital", type:"cluster", severity:"high", contribution: 81 },
        { id: 2, name: "Policy and Insured", type:"cluster", severity:"medium", contribution: 10 },
        { id: 3, name: "Advisor", type:"cluster", severity:"medium", contribution: 9 },
        { id: 4, name: "Sales Person", type:"cluster", severity:"low", contribution: 0 },
        // { id: 5, name: "Diagnosis Grouper", type:"cluster", severity:"low", contribution: 0 },
      ],
      clustersData: DATA_DFC['default']
    },
    
  };
  
  //data = Object.assign({},this.dataSETDemo.high);
  data = Object.assign({},this.dataSETDemo.high);

  fraudDeatils = [];
  fraudScore = 0;
  propensity=0;
  modelPrediction = null;
  recommendation = null;
  enableAnalyticsPanel = false

  
  initData() {
    this.data.cna.forEach( (d,i) => {
      this.data.cna[i] = Object.assign({},this.ranges.find(r=>r.name===d.severity),d);
    });
  }
  fraudIO:any
  setClusterData(){
    DATA_DFC.default['propensityScore'] = this.generateRandom();
    DATA_DFC.default['rating'] = this.updateRating(DATA_DFC['default']['propensityScore']);
    this.fraudIO=DATA_DFC['default'];
    this.data['clustersData']=DATA_DFC['default']
    this.cnaTableData = this.data.clustersData||[];
    this.cnaTableDataCopy = JSON.parse(JSON.stringify(this.data.clustersData));
    this.pie=this.pieMake();
  }

  constructor( 
    private viewContainerRef: ViewContainerRef,
    private interactService: InteractService,
    public dataTransformService:DataTransformService,
    public commonUtility: CommonUtilty,
    public apiRequestService : ApiRequestService,
    public msg : NzMessageService) { }
  ngOnInit(): void {

    this.setClusterData()
    this.subscribeToParentEvent()
    this.initData();
    this.pseudoLoad();
    if(this.IO)
    this.fetchFraudDeatils();

    if(this.primaryInsured && this.primaryInsured.name){
      let details = this.dataSet.filter(item=> item.name == this.primaryInsured.name)
      this.userDetails = details && this.commonUtility.isArrayIterable(details) ? details[0] ? details[0] : this.dataSet[0] : this.dataSet[0]
    }
    
  }
  getClientDOlistWithRole(IO) {
    let output = []
  if (IO) {
    let PRIMARYINSUREDLIST = this.commonUtility.extractClientDOListFromIOGeneric(IO, 'PRIMARYINSURED');
    let INSUREDLIST = this.commonUtility.extractClientDOListFromIOGeneric(IO, 'INSURED');
    if (PRIMARYINSUREDLIST && Array.isArray(PRIMARYINSUREDLIST))
      output.push(...PRIMARYINSUREDLIST);
    if (INSUREDLIST && Array.isArray(INSUREDLIST))
      output.push(...INSUREDLIST)
  }
  return output
  }
  fetchFraudDeatils(){
    let url = 'fetchBatchLog'
    let pathVariables = [];
    pathVariables.push(this.IO.proposalNum);
    this.apiRequestService.getCallWithAPIMapper(url, null, null).subscribe(resp =>{
      if(resp)
        this.fraudDeatils = resp
      else this.msg.error("Server Error : Please check with system administrator")

      if(this.fraudDeatils && this.commonUtility.isArrayIterable){
        this.fraudDeatils.forEach(detail => {
          if(detail.batchName && detail.batchName == 'PROBABILITY'){
            let propensityRespData = this.commonUtility.deepCopy([JSON.parse(detail.responseData)]);
            this.propensity = propensityRespData[0] ? propensityRespData[0].claim_prediction_years ? propensityRespData[0].claim_prediction_years : null : null;
          }
          if(detail.batchName && detail.batchName == 'FWA_RISK'){
            let fraudScoreRespData = this.commonUtility.deepCopy([JSON.parse(detail.responseData)]);
           this.fraudScore = fraudScoreRespData[0] ? fraudScoreRespData[0].predictionProbabilityPercent ? fraudScoreRespData[0].predictionProbabilityPercent : null : null;
            this.modelPrediction = fraudScoreRespData[0] ? fraudScoreRespData[0].modelPrediction ? fraudScoreRespData[0].modelPrediction : null : null;
            this.recommendation = fraudScoreRespData[0] ? fraudScoreRespData[0].overallInvestigationRecommendation ? fraudScoreRespData[0].overallInvestigationRecommendation : null : null;
          }
        })
      }
    })
  }
  /* Loading / pseudoLoad */
  /* DEMO-ONLY PSEUDO-LOADING CODE */
  isLoading = true;
  isLoadingText = "Analyzing";
  isLoadingPerc = 10;
  pseudoLoad(t=0) {
    this.isLoading = true;
    let totalFakeLoadTime = t||5125;
    let divisions = 5;
    setTimeout(()=>{this.isLoadingPerc=20; this.isLoadingText = "Loading models"},~~(totalFakeLoadTime/divisions));
    setTimeout(()=>{this.isLoadingPerc=40; this.isLoadingText = "Calculating propensity score"},~~(totalFakeLoadTime/divisions)*2);
    // setTimeout(()=>{this.isLoadingPerc=60; this.isLoadingText = "Checking for anomalies"},~~(totalFakeLoadTime/divisions)*3);
    // setTimeout(()=>{this.isLoadingPerc=80; this.isLoadingText = "Analyzing models"},~~(totalFakeLoadTime/divisions)*4);
    setTimeout(()=>{this.isLoadingPerc=100;this.isLoadingText = "Loading Recommendation Summary"},~~(totalFakeLoadTime/divisions)*5);
    setTimeout(()=>{this.isLoading=false},totalFakeLoadTime+650);
  }


  /* Functions for getting Gauge values */
  getClaimRisk = () => this.data.risk;
  getFraudPropensity = (percent: number) => `${percent}`;

  getRiskValue = () => this.fraudIO.rating

  /* Clusters and Anomalies */
  cnaSelected = this.data.cna[0];
  cnaTableData = this.data.clustersData||[];
  cnaTableDataCopy = JSON.parse(JSON.stringify(this.data.clustersData));
  isLoadingCnA = false;
  calcna(d) {
    // Loader
    this.isLoadingCnA = true;
    setTimeout(()=>this.isLoadingCnA=false,512);
    // Sp.Case
    if(this.cnaSelected && this.cnaSelected.id===d.id)
      return setTimeout(()=>this.cnaSelected = null,512); // Un-select
    // Set Data
    this.cnaSelected = d;
    // Find Table Data
    this.cnaTableData = this.cnaTableDataCopy
    if(d.type=='all') {
      this.cnaTableData = this.data.clustersData;
      this.pie=this.pieMake();
    }
    else {
      let temp=this.data;
      let anomalies= temp.clustersData.anomalies.filter(e=>e.cluster==this.cnaSelected.name); 
      this.cnaTableData['anomalies'] =anomalies
      let piedata=[]
      piedata.push({"name":d.name,"value":d.contribution})
      this.pie=piedata;
    }
    
    
    
  }


  // INVESTIGATION DATA OBJ
  dataInv = {
    // Status
    status: "Rejected",
    statusDATA: ["Approved","Rejected","Inconclusive"],
    statusRemarks: "The investigation was concluded to be a fraud conducted by the Hospital",

    // Reasons for Rejection
    overallReasons: ['Fraud','Misrepresentation'],
    overallReasonsDATA: ['Fraud','Abuse','Waste','Waste & Abuse','Misrepresentation'],

    // Who's responsible?
    responsibility: ['Hospital','Pharmacy'],
    responsibilityDATA: ['Insured','Advisor','Hospital','Pharmacy','Others'],
  }



  /* CHARTS */

  pieMake = () => this.data.clustersData.cna.filter(e=>e.name!=="All"&&e.severity!=='low').map( e => { return { name: e.name, value: e.contribution} } )
  pie = this.pieMake();
  pieView = [280, 175];

  viewHorizBar = [640, 45];
  showXAxis = false;showYAxis = false;gradient = false;showLegend = false;
  showXAxisLabel = true;showYAxisLabel = false;yAxisLabel = '';xAxisLabel = '';
  onChartClick(event) { console.log(event) }

  // Chart colors
  // IMP: THIS SHOULD BE A DYNAMICALLY GENERATED ARRAY, BASED ON CLUSTER RED/GREENs
  colorScheme = {
    domain: ['#d63f3f', '#f69822', '#e37c2a', '#bf710c'],
  };


  // UI DEMO SWITCHER
  change(stg) {
    // Data switcher
    if(stg==='data') {
      switch (this.dataSample.toLowerCase()) {
        // case 'low': this.data = this.dataSETDemo.low; break;
        // case 'medium': this.data = this.dataSETDemo.medium; break;
        // case 'high': this.data = this.dataSETDemo.high; break;
      }
    }
    // User type switch
    else {
      this.pseudoLoad(980);
    }
    this.initData();
    this.pieMake();
  }

  /*Actual data inmplementation */

  _IO
  @Input()
  set IO(data) {
    
    if (data) {
      this._IO = this.ServerToUITransform(data);
      this._IO = data;
      this.clientDoList=this.getClientDOlistWithRole(this._IO)
      let listOfPrimaryInsured = this.commonUtility.extractClientDOFromIOGeneric(data, 'PRIMARYINSURED');
    this.primaryInsured = listOfPrimaryInsured ? listOfPrimaryInsured[0] ? listOfPrimaryInsured[0] : null : null
    }
  }

  BaseEmitHandler(event){
    
   // this.EmitComponentOutput(outPut)
  }

  UItoServerTransform(payload, response) {
    
    return payload;
  }

  ServerToUITransform(payload) {
    return payload;
  }


  parentEvent$
  subscribeToParentEvent() {
    if (this.parentEvent$ != null)
      this.parentEvent$.unsubscribe()
    this.parentEvent$ = this.interactService.pingSubject$.subscribe((param: any) => {
      let isOutputValid = true
      if (isOutputValid) {
        this.askAllChildrenForData();
      }
      else {
        this.EmitComponentOutput("ERROR")
      }
    })

  }

  EmitComponentOutput(data) {
    let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.componentOutput,this.UItoServerTransform)
  }
  getParentComponent(): Component {
    try {
      return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component
    } catch { }
  }
  getParentComponentName(): string {
    try {
      return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name
    } catch { }
  }
  getCurrentComponentName(): string {
    return this._currentComponentName
  }

  childSubject:any
  askAllChildrenForData() {
    this.childSubject=this.interactService.pingFraudRuleChildToReact(this.getCurrentComponentName())
  }

  allAnomalies
  searchRules(value) {
    if (value) {
      this.allAnomalies=this.cnaTableData['anomalies'];
      this.cnaTableData['anomalies'] = this.cnaTableData['anomalies'].filter(item => item.message ? item.message.toLowerCase().includes(value.toLowerCase()) : false);
    }
  }
  searchValue = '';

  reset(): void {
    this.searchValue = '';
    this.cnaTableData['anomalies'] = this.cnaTableData['anomalies'].filter(x => x.message);
    this.cnaTableData['anomalies']=this.allAnomalies
  }

  searchCluster(value) {
    if (value) {
      this.cnaTableData['anomalies'] = this.cnaTableData['anomalies'].filter(item => item.cluster ? item.cluster.toLowerCase().includes(value.toLowerCase()) : false);
    }
  }

  resetCluseter(): void {
    this.searchValue = '';
    this.cnaTableData['anomalies'] = this.cnaTableData['anomalies'].filter(x => x.cluster);
    this.cnaTableData['anomalies']=this.allAnomalies
  }

  updateRating(score){
    if(score > 70)
      return 'High';
    if(score < 70 && score > 25)
      return 'Medium';
    if(score < 25)
      return 'Low';
  }

  generateRandom(maxLimit = 100){
    let rand = Math.random() * maxLimit;  
    rand = Math.floor(rand); 
    return rand;
  }

  dataSet = [
    {
      key    : '1',
      name   : 'John Doe',
      recommendation: "Accept with standard premium rates."
    },
    {
      key    : '2',
      name   : 'Alice Smith',
      recommendation: "Reject as Cancer reported, which significantly increases health risks.",
      
    },
    {
      key    : '3',
      name   : 'Dan Miller',
      recommendation: "Accept with Revised Terms. Monitor tobacco consumption and manage diabetes effectively. Consider follow-up health checks.",
      
    },
    {
      key    : '4',
      name   : 'Liem Kim',
      recommendation: "Accept with Revised Terms. Reduced Sum Assured due to existing policy.",
      
    },
  ]

}
